import { NavLink, useLocation } from "react-router-dom";

import { HorizontalFlexbox } from "@src/shared/components/layout/Flexbox";
import { cn } from "@src/shared/lib/utils";
import { navigationV2 } from "@src/shared/navigation/v2";

export type PatientDetailTabV2 = "agenda" | "visits";

export interface PatientDetailTabsV2Props {
  patientId: number;
  activeTab: PatientDetailTabV2;
}

function tabClassName({ isActive }: { isActive: boolean }) {
  return cn(
    "rounded-[7px] px-3 py-2 text-[13px] font-medium text-muted-foreground transition-colors",
    isActive && "bg-primary/10 font-semibold text-primary",
  );
}

export function PatientDetailTabsV2({
  patientId,
  activeTab,
}: PatientDetailTabsV2Props) {
  const id = String(patientId);
  const location = useLocation();

  return (
    <HorizontalFlexbox
      role="tablist"
      aria-label="Patient detail"
      className="gap-1.5 border-b border-border px-[18px] py-2 md-stitch:px-6"
    >
      <NavLink
        role="tab"
        aria-selected={activeTab === "agenda"}
        to={navigationV2.patientDetail(id)}
        end
        replace
        state={location.state}
        className={() => tabClassName({ isActive: activeTab === "agenda" })}
      >
        Agenda
      </NavLink>
      <NavLink
        role="tab"
        aria-selected={activeTab === "visits"}
        to={navigationV2.patientVisits(id)}
        replace
        state={location.state}
        className={() => tabClassName({ isActive: activeTab === "visits" })}
      >
        Past Visits
      </NavLink>
    </HorizontalFlexbox>
  );
}
